export default __webpack_public_path__ + "static/media/image8.204ed1af.png";